window.jsonDetailFormatter = function(value, row) {
    let html = '';
    if (row.json.data) {
        html += '<div class="form-group">';
        html += "<label>"+row.json.label+"</label>";
        html += '<textarea class="form-control" rows="3">'+row.json.data+"</textarea>";
        html += "</div>";
    }
    return html;
};
